package org.hs_soft.runmynesto.pages.login.mvi

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModel
import org.hs_soft.runmynesto.domain.model.login.LoginStateEnum
import org.hs_soft.runmynesto.domain.usecase.login.IsLoggedInUseCase
import org.hs_soft.runmynesto.domain.usecase.login.ResetPasswordUseCase
import org.hs_soft.runmynesto.domain.usecase.login.SendCodeForRestPassUseCase
import org.hs_soft.runmynesto.domain.usecase.login.SignInUseCase
import org.hs_soft.runmynesto.domain.util.Constants

class LoginViewModel(
    private val signInUseCase: SignInUseCase,
    private val isLoggedInUseCase: IsLoggedInUseCase,
    private val sendCodeForRestPassUseCase: SendCodeForRestPassUseCase,
    private val resetPasswordUseCase: ResetPasswordUseCase,
)
{
    private val _state = MutableStateFlow(LoginState())
    val state: StateFlow<LoginState> = _state
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    fun onEvent(event: Any) {
        when (event)
        {
            is LoginEvent.ResetPassword->{
                resetPassword(
                    verifyCode=event.verifyCode,
                    newPassword=event.newPassword,
                    userName=state.value.userName,
                )
            }

            is LoginEvent.SendCodeForResetPassword->{
                sendCodeForResetPassword(
                    email=event.userName
                )
            }
            is LoginEvent.SetLoginState->{
                _state.value=_state.value.copy(
                    loginState = event.loginState,
                    isLoading = false,
                )
            }
            is LoginEvent.InitWindowsSize ->{
               initWindowSize(windowsSize = event.windowsSize)
            }


            is LoginEvent.UpdateIsLoggedInStatus ->{
                updateIsLoggedInStatus()

            }

            is LoginEvent.OnPasswordChange ->{
                _state.value=_state.value.copy(
                    password = event.value
                )
            }
            is LoginEvent.OnMFAChange ->{
                _state.value=_state.value.copy(
                    mfaCode = event.value
                )
            }

            is LoginEvent.OnUserNameChange ->{
                _state.value=_state.value.copy(
                    userName = event.value
                )
            }

            is LoginEvent.OnSignInClick ->{
                signIn(
                    onSuccess = {
                        event.onSuccess()
                     }
                )



            }
            is LoginEvent.OnFailureLogin ->{
                _state.value=_state.value.copy(
                    errorMsg =event.error,
                    isLoading = false,
                )
            }

            else -> {}
        }



    }

    private fun resetPassword(
        verifyCode: String,
        newPassword: String,
        userName: String,
    ) {
        scope.launch {
            _state.value = _state.value.copy(
                isLoading = true
            )
            try {
                resetPasswordUseCase(
                    verifyCode=verifyCode,
                    newPassword=newPassword,
                    userName=userName,
                    onSuccess = {
                        _state.value = _state.value.copy(
                            isLoading = false,
                            loginState = LoginStateEnum.SIGN_IN
                        )
                    },
                    onError = {
                        _state.value = _state.value.copy(
                            isLoading = false,
                        )
                    }
                )
            } catch (e: Exception) {
                _state.value = _state.value.copy(
                    isLoading = false,
                )
            }
        }

    }

    private fun sendCodeForResetPassword(email: String)
    {
        scope.launch {
            _state.value = _state.value.copy(
                isLoading = true
            )
            try {
                 sendCodeForRestPassUseCase(
                    email=email,
                    onSuccess = {
                        _state.value = _state.value.copy(
                            isLoading = false,
                            loginState = LoginStateEnum.RESET_PASSWORD
                        )
                    },
                    onError = {
                        _state.value = _state.value.copy(
                            isLoading = false,
                        )
                    }
                )
            } catch (e: Exception) {
                _state.value = _state.value.copy(
                    isLoading = false,
                )
            }
        }


    }

    private fun initWindowSize(windowsSize: WindowSizeModel) {
        if(windowsSize.width> Constants.Responsive.MaxTabletWidth){
            _state.value=_state.value.copy(
                windowSizeMode = WindowSizeModeEnum.Desktop
            )
        }else if(windowsSize.width< Constants.Responsive.MaxTabletWidth
            && windowsSize.width> Constants.Responsive.MaxPhoneWidth){
            _state.value=_state.value.copy(
                windowSizeMode = WindowSizeModeEnum.TABLET
            )
        }else{
            _state.value=_state.value.copy(
                windowSizeMode = WindowSizeModeEnum.PHONE
            )
        }

    }

    private fun updateIsLoggedInStatus() {
        scope.launch {
            _state.value = _state.value.copy(
                isCheckingLoggedInLoading = true
            )
            try {
                val result = isLoggedInUseCase()
                _state.value = _state.value.copy(
                    isCheckingLoggedInLoading = false, isLoggedIn = result
                )
            } catch (e: Exception) {
                _state.value = _state.value.copy(
                    isCheckingLoggedInLoading = false, isLoggedIn = false
                )
            }
        }
    }

    private fun signIn(
        onSuccess:()->Unit,
    ) {
        scope.launch {
            _state.value = _state.value.copy(isLoading = true)
            try {
                signInUseCase(
                    userName = state.value.userName,
                    password = state.value.password,
                    mfaCode = state.value.mfaCode,
                    isSecondStep = state.value.loginState==LoginStateEnum.VERIFY_SIGN_IN_CODE,
                    goToSecondStep = {
                         _state.value=_state.value.copy(
                             loginState = LoginStateEnum.VERIFY_SIGN_IN_CODE,
                             errorMsg = "",
                             isLoading = false,
                         )
                    },
                    onSuccess = {
                        onSuccess()
                    },
                    onError = {
                        _state.value = _state.value.copy(
                            errorMsg = it,
                            isLoading = false,
                        )
                    }
                )
            } catch (e: Exception) {
                _state.value = _state.value.copy(
                    errorMsg = e.message.toString(),
                    isLoading = false,
                )
            }
        }
    }


}

